const PaletteMap = [
  {
    id: 0,
    fileName: 'glasses-black.svg',
    first: '#000000',
    second: '#000000',
    third: '#000000',
    fourth: '#000000',
  },
  {
    id: 1,
    fileName: 'glasses-beige.svg',
    first: '#d19a54',
    second: '#d19a54',
    third: '#d19a54',
    fourth: '#d19a54',
  },
  {
    id: 2,
    fileName: 'glasses-blue-green.svg',
    first: '#068940',
    second: '#068940',
    third: '#257ced',
    fourth: '#257ced',
  },
  {
    id: 3,
    fileName: 'glasses-blue.svg',
    first: '#5648ed',
    second: '#5648ed',
    third: '#5648ed',
    fourth: '#5648ed',
  },
  {
    id: 4,
    fileName: 'glasses-dark-pink.svg',
    first: '#b9185c',
    second: '#b9185c',
    third: '#b9185c',
    fourth: '#b9185c',
  },
  {
    id: 5,
    fileName: 'glasses-gray.svg',
    first: '#9cb4b8',
    second: '#9cb4b8',
    third: '#9cb4b8',
    fourth: '#9cb4b8',
  },
  {
    id: 6,
    fileName: 'glasses-green.svg',
    first: '#4bea69',
    second: '#4bea69',
    third: '#4bea69',
    fourth: '#4bea69',
  },
  {
    id: 7,
    fileName: 'glasses-orange.svg',
    first: '#fe500c',
    second: '#fe500c',
    third: '#fe500c',
    fourth: '#fe500c',
  },
  {
    id: 8,
    fileName: 'glasses-pink.svg',
    first: '#cc0595',
    second: '#cc0595',
    third: '#cc0595',
    fourth: '#cc0595',
  },
  {
    id: 9,
    fileName: 'glasses-red-eye.svg',
    first: 'black',
    second: 'black',
    third: 'red',
    fourth: 'red',
  },
  {
    id: 10,
    fileName: 'glasses-red.svg',
    first: '#f3322c',
    second: '#f3322c',
    third: '#f3322c',
    fourth: '#f3322c',
  },
  {
    id: 11,
    fileName: 'glasses-rgb.svg',
    first: '#0adc4d',
    second: '#1929f4',
    third: 'red',
    fourth: '#000000',
  },
  {
    id: 12,
    fileName: 'glasses-sky-blue.svg',
    first: '#2b83f6',
    second: '#2b83f6',
    third: '#2b83f6',
    fourth: '#2b83f6',
  },
  {
    id: 13,
    fileName: 'glasses-teal.svg',
    first: '#ff638d',
    second: '#ff638d',
    third: '#ff638d',
    fourth: '#ff638d',
  },
  {
    id: 14,
    fileName: 'glasses-yellow-dark.svg',
    first: '#f78a18',
    second: '#f78a18',
    third: '#f98f30',
    fourth: '#f98f30',
  },
  {
    id: 15,
    fileName: 'glasses-yellow.svg',
    first: '#ffef16',
    second: '#ffef16',
    third: '#ffef16',
    fourth: '#ffef16',
  },
  {
    id: 16,
    fileName: 'glasses-black-full.svg',
    first: '#ffffff',
    second: '#000000',
    third: '#000000',
    fourth: '#000000',
  },
];

export default PaletteMap;
